<template>
  <div class="app-container">
    <list ref="list"></list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from '@/components/sys/initialize/initcustomerin/list'

export default {
  name: "initcustomerin",
  mixins: [curdMixins],
  components: {
    list,
  },
  methods: {}
};
</script>